import { FC, memo, useEffect, useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { gtmApi } from '@barracuda/shared/analytics/gtm';

import './OneTrustBanner.styles.css';

// Client-Side Cookie Management: https://community.cookiepro.com/s/article/UUID-730ad441-6c4d-7877-7f85-36f1e801e8ca?language=en_US
export const OneTrustBanner: FC<{
  readonly apiKey: string;
  readonly consentUpdate: () => void;
}> = memo(({ apiKey, consentUpdate }) => {
  const isInTestMode = process.env.REACT_APP_ONETRUST_TESTING === 'true';
  const consentUpdateRef = useRef(consentUpdate);
  consentUpdateRef.current = consentUpdate;

  // ensure the method is already defined BEFORE render
  window.OptanonWrapper = () => consentUpdateRef.current();

  useEffect(() => {
    window.OptanonWrapper = () => consentUpdateRef.current();

    // ensure GTM initializes after OT
    gtmApi.install();
  }, []);

  const effectiveApiKey = useMemo(
    () => `${apiKey}${isInTestMode ? '-test' : ''}`,
    [apiKey, isInTestMode]
  );

  return (
    <Helmet>
      <script
        src={`https://cdn.cookielaw.org/consent/${effectiveApiKey}/otSDKStub.js`}
        data-document-language='true'
        type='text/javascript'
        charSet='UTF-8'
        data-domain-script={effectiveApiKey}
      ></script>
    </Helmet>
  );
});
